export default {
      id: "calendar-red-usage",
      viewBox: "0 0 17 18",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#calendar-red",
      toString: function () {
        return this.url;
      }
    }